import { Component, effect, signal } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cope-spinner',
  template: `
     <div class="spinner-overlay">
      <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
    </div>
  `,
  imports:[MatProgressSpinnerModule,CommonModule],
    standalone: true,

  styles: [`
    .spinner-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }
  `]
})
export class CopeSpinnerComponent {
  loading = signal(false);

  constructor(public authService: AuthService) {
    // effect(() => {
    //   this.loading.set(this.authService.loading());
    // });
  }
}
